import { Pipe, PipeTransform } from "@angular/core";
import { isObject } from "ionic-angular/util/util";

@Pipe({ name: "toArray" })
export class ToArrayPipe implements PipeTransform {

  public transform(input: any, keys: boolean = false): any[] {
    if (!isObject(input)) { return input; }

    return Object.keys(input).map((value) => {
      if ( keys) { return { key: value, val: input[value] }; }
      if (!keys) { return input[value]; }
    });
  }
}



// WEBPACK FOOTER //
// ./src/pipes/to-array/to-array.ts